import script from "./SoonExhibits.vue?vue&type=script&setup=true&lang=js"
export * from "./SoonExhibits.vue?vue&type=script&setup=true&lang=js"

import "./SoonExhibits.vue?vue&type=style&index=0&id=36b0ad16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b0ad16"]])

export default __exports__